/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

// import * as bootstrap from 'bootstrap';
// window.bootstrap = bootstrap;

// require('./theme');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });



// Get references to the parent and child elements
const parentElement = document.getElementById('searchBox');
const childElement = document.getElementById('searchBoxContent');

// Get the height of the child element
const childHeight = childElement.offsetHeight;

// Set the height of the parent element to match the child element's height
parentElement.style.height = `${childHeight}px`;

// Optional: If child content might change dynamically, you can update the parent's height
// whenever the content of the child element changes:
const observer = new MutationObserver(() => {
    const updatedChildHeight = childElement.offsetHeight;
    parentElement.style.height = `${updatedChildHeight}px`;
});

// Start observing the child element for changes
observer.observe(childElement, { childList: true, subtree: true, characterData: true });